import { Box, Stack, Typography } from "@mui/material";
import DeepchatNavigationTabs from "../DeepchatNavigationTabs";
import FileUploadPanel from "./FileUploadPanel";
import { SidebarActivePanelAtom } from "../state/DeepchatState";
import { useEffect } from "react";
import { useAtom } from "jotai";
import { SIDEBAR_STATE } from "../../../constants/sidebarEnums";

export default function SummarizeDocument() {
  const [, setActivePanel] = useAtom(SidebarActivePanelAtom);

  useEffect(() => {
    setActivePanel(SIDEBAR_STATE.CLOSED);
  }, []);

  return (
    <Box minHeight="100%" width="100%" maxWidth="48rem">
      <Stack
        className="QuestionInput"
        direction="column"
        marginTop="20vh"
        alignItems="center"
        spacing={4}
        sx={{ minHeight: "100%" }}
      >
        <Typography variant="h3" fontWeight="bold" color={"rgb(0, 48, 135)"}>
          Welcome
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <DeepchatNavigationTabs />
          <FileUploadPanel />
        </Box>
      </Stack>
    </Box>
  );
}
